var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Notification } from '../../components';
var defaultPosition = {
    vertical: 'bottom',
    horizontal: 'right'
};
export var useNotifications = function () {
    var _a = useSnackbar(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar;
    var getNotification = useCallback(function (variant) {
        if (variant === void 0) { variant = 'default'; }
        return function (content, icon, options) {
            var closeNotification = function () {
                if (!notificationId) {
                    return;
                }
                closeSnackbar(notificationId);
            };
            var notificationId = enqueueSnackbar('', __assign({ anchorOrigin: defaultPosition, 
                // eslint-disable-next-line react/display-name
                content: function (key) { return (React.createElement(Notification, { variant: variant, content: content, iconName: icon, onClose: closeNotification, key: key })); } }, options));
            return notificationId;
        };
    }, [closeSnackbar, enqueueSnackbar]);
    var showCustomNotification = useCallback(function (Content, position, options) {
        return enqueueSnackbar('', __assign({ anchorOrigin: position || defaultPosition, 
            // eslint-disable-next-line react/display-name
            content: function (key) { return React.cloneElement(Content, { key: key }); } }, options));
    }, [enqueueSnackbar]);
    return {
        showError: useMemo(function () { return getNotification('error'); }, [getNotification]),
        showInfo: useMemo(function () { return getNotification(); }, [getNotification]),
        showWarning: useMemo(function () { return getNotification('warning'); }, [getNotification]),
        showSuccess: useMemo(function () { return getNotification('success'); }, [getNotification]),
        showCustomNotification: showCustomNotification,
        closeNotification: closeSnackbar
    };
};
//# sourceMappingURL=useNotifications.js.map